import { useState } from "react";
import FieldRenderer from "./FieldRenderer";

/** Repeater: adds/removes/reorders sub-forms. */
export default function Repeater({ field, value, onChange, path }) {
  const items = Array.isArray(value) ? value : [];
  const [expanded, setExpanded] = useState(0);

  const addItem = () => {
    const empty = {};
    (field.fields || []).forEach((f) => {
      empty[f.key] = f.type === "repeater" || f.type === "list" ? [] : "";
    });
    onChange([...items, empty]);
    setExpanded(items.length);
  };
  const removeItem = (i) => onChange(items.filter((_, j) => j !== i));
  const move = (from, to) => {
    if (to < 0 || to >= items.length) return;
    const arr = [...items];
    [arr[from], arr[to]] = [arr[to], arr[from]];
    onChange(arr);
    setExpanded(to);
  };
  const patch = (i, k, v) => {
    const arr = [...items];
    arr[i] = { ...arr[i], [k]: v };
    onChange(arr);
  };
  const itemName = (it, i) => {
    try { return (field.itemLabel && field.itemLabel(it)) || `Item ${i + 1}`; }
    catch { return `Item ${i + 1}`; }
  };

  return (
    <div className="space-y-2" data-testid={`${path}-repeater`}>
      {items.map((it, i) => (
        <div key={i} className="border border-[#E5E7EB] rounded-lg bg-white">
          <div
            className="flex items-center justify-between px-3 py-2 cursor-pointer hover:bg-[#F8FAF7] transition-colors"
            onClick={() => setExpanded(expanded === i ? -1 : i)}
          >
            <div className="flex items-center gap-2 text-sm">
              <span className="w-5 h-5 rounded bg-[#EAF4E3] text-[#09582D] text-[11px] font-semibold flex items-center justify-center">
                {i + 1}
              </span>
              <span className="font-medium text-gray-900">{itemName(it, i)}</span>
            </div>
            <div className="flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
              <button type="button" onClick={() => move(i, i - 1)}
                data-testid={`${path}-repeater-up-${i}`}
                disabled={i === 0}
                className="p-1 text-gray-400 hover:text-gray-700 disabled:opacity-30">▲</button>
              <button type="button" onClick={() => move(i, i + 1)}
                data-testid={`${path}-repeater-down-${i}`}
                disabled={i === items.length - 1}
                className="p-1 text-gray-400 hover:text-gray-700 disabled:opacity-30">▼</button>
              <button type="button" onClick={() => removeItem(i)}
                data-testid={`${path}-repeater-remove-${i}`}
                className="p-1 text-gray-400 hover:text-[#DC2626]">×</button>
            </div>
          </div>
          {expanded === i && (
            <div className="p-4 border-t border-[#E5E7EB] bg-[#F8FAF7]/50">
              {(field.fields || []).map((f) => (
                <FieldRenderer
                  key={f.key} field={f}
                  value={it[f.key]}
                  onChange={(v) => patch(i, f.key, v)}
                  path={`${path}-${i}`}
                />
              ))}
            </div>
          )}
        </div>
      ))}
      <button
        type="button" onClick={addItem}
        data-testid={`${path}-repeater-add`}
        className="w-full py-2 border-2 border-dashed border-gray-300 rounded-lg text-sm text-gray-600 hover:border-[#538135] hover:text-[#09582D] hover:bg-[#EAF4E3]/30 transition-colors"
      >
        + Add {field.label?.replace(/s$/, "").toLowerCase() || "item"}
      </button>
    </div>
  );
}
